import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getEquiposAuxiliares = async() => {
    const result = await PrivateInterceptor(`Global/EquiposAuxiliares`, 'GET',)
    return result;
}

export const getEquiposAuxiliaresByArea = async(IdArea) => {
    const result = await PrivateInterceptor(`Global/EquiposAuxiliares/${IdArea}`, 'GET',)
    return result;
}